import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { DataContext } from "../../components/layouts/main-layout";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import InputField from "../../components/forms/input-field";
import AddButton from "../../components/buttons/button";
import successToast from "../../components/helper-components/success-toast";
import errorToast from "../../components/helper-components/error-toast";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import { api } from "../../redux/apis/api";
 
const validationSchema = Yup.object().shape({
  account_name: Yup.string().required("Account Name is required"),
  account_number: Yup.string().required("Account Number is required"),
  bank_name: Yup.string().required("Bank Name is required"),
  ifsc_code: Yup.string().required("IFSC Code is required"),
  firm_name: Yup.string().required("Firm Name is required"),
});
 
const AccountDetails = () => {
  const { permissionFn } = useContext(DataContext);
  const [loading, setLoading] = useState(true);
  const [existingId, setExistingId] = useState(null);
  const [initialValues, setInitialValues] = useState({
    account_name: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
    firm_name: "",
    support_mobile_number: "",
    support_email: "",
  });
 
  useEffect(() => {
    api
      .get("/fofo/storeAccountDetails/getAll")
      .then((res) => {
        const data = res?.data?.data;
        const record = Array.isArray(data) ? data[0] : data;
        if (record) {
          setExistingId(record.acount_details_id ?? record.id ?? null);
          setInitialValues({
            account_name: record.account_name ?? "",
            account_number: record.account_number ?? "",
            bank_name: record.bank_name ?? "",
            ifsc_code: record.ifsc_code ?? "",
            firm_name: record.firm_name ?? "",
            // Returned by getAll but had no field here, so the support contact
            // never showed and a save sent nothing back for it.
            support_mobile_number: record.support_mobile_number ?? "",
            support_email: record.support_email ?? "",
          });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);
 
  const onSubmit = (values, { setSubmitting }) => {
    const endpoint = existingId
      ? "/fofo/storeAccountDetails/update"
      : "/fofo/storeAccountDetails/add";
    const payload = existingId
      ? { ...values, acount_details_id: existingId }
      : values;
 
    api
      .post(endpoint, payload)
      .then((res) => {
        // The API answers 200 with { status: false } on failure, so the body has
        // to be checked or a failed save reports success.
        if (res.data?.status === false) {
          errorToast(res.data?.message ?? "Failed to save account details");
          return;
        }
        successToast(res.data?.message ?? "Account details saved successfully");
        if (!existingId) {
          const newId = res.data?.data?.acount_details_id ?? res.data?.data?.id;
          if (newId) setExistingId(newId);
        }
      })
      .catch((err) => {
        errorToast(err?.response?.data?.message ?? "Failed to save account details");
      })
      .finally(() => setSubmitting(false));
  };
 
  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="store_execution_process"
      title="Account Details"
    >
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="h-full flex flex-col justify-between">
              <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 pt-5">
                <InputField
                  type="text"
                  name="account_name"
                  placeholder="Enter Account Name"
                  label="Account Name"
                  isRequired={true}
                  labelWidth="10.5rem"
                />
                <InputField
                  type="text"
                  name="account_number"
                  placeholder="Enter Account Number"
                  label="Account Number"
                  isRequired={true}
                  labelWidth="10.5rem"
                />
                <InputField
                  type="text"
                  name="bank_name"
                  placeholder="Enter Bank Name"
                  label="Bank Name"
                  isRequired={true}
                  labelWidth="10.5rem"
                />
                <InputField
                  type="text"
                  name="ifsc_code"
                  placeholder="Enter IFSC Code"
                  label="IFSC Code"
                  isRequired={true}
                  labelWidth="10.5rem"
                />
                <InputField
                  type="text"
                  name="firm_name"
                  placeholder="Enter Firm Name"
                  label="Firm Name"
                  isRequired={true}
                  labelWidth="10.5rem"
                />
                <InputField
                  type="text"
                  name="support_mobile_number"
                  placeholder="Enter Support Mobile Number"
                  label="Support Mobile Number"
                  labelWidth="10.5rem"
                />
                <InputField
                  type="text"
                  name="support_email"
                  placeholder="Enter Support Email"
                  label="Support Email"
                  labelWidth="10.5rem"
                />
              </div>
              <div
                className="flex justify-end px-10 mb-5 sticky bg-white py-4 invoice-bottom-container"
                style={{ bottom: 0 }}
              >
                <AddButton
                  prefixIcon={false}
                  text="Save"
                  type="submit"
                  loading={isSubmitting}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </InnerLayout>
  );
};
 
export default AccountDetails;